const languageLoaders: Record<string, () => void> = {
    en: () => require('lang/en/en.js'), // moment.js doesn't ship with 'en' or 'en-us' so we made our own
    es: () => require('moment/locale/es'),
    it: () => require('moment/locale/it'),
    fr: () => require('moment/locale/fr'),
};

//
// This causes all the date/time strings to appear in the correct language.
// All the other strings come from our string tables in /client/src/lang.
//
export function loadLanguage(langCode: string): void {
    langCode = langCode.toLowerCase();
    const languageLoader = languageLoaders[langCode] || languageLoaders.en;
    languageLoader();
}
